import {Injectable} from '@angular/core'
import * as firebase from 'firebase/app'
import {environment} from '../../../environments/environment'
import {LoaderService} from '../../ui-shared/loader/loader.service'
declare var zip

export class Upload {
  $key: string
  file: File
  name: string
  url: string
  progress: number
  createdAt: Date = new Date()
  constructor(file: File) {
    this.file = file
  }
}

@Injectable()
export class StorageService {
  constructor(public loader: LoaderService) {
    zip.workerScriptsPath = '/assets/js/zipjs/'
  }

  get storagePath(): string {
    return (
      'https://' +
      environment.firebase.storageBucket +
      '.storage.googleapis.com/'
    )
  }

  downloadFiles(files: Array<any>, archiveName: string) {
    let zipFs = new zip.fs.FS()
    let _ = this
    let archive = []
    const names = {}

    this.loader.start('Preparing for download...')
    // console.log('Start downloading', archiveName, files)

    for (let i in files) {
      let file = files[i]
      if (file.files)
        archive = archive.concat(
          file.files.map(path =>
            path.indexOf(this.storagePath) < 0 ? this.storagePath + path : path
          )
        )
      else archive.push(file.path)
    }

    let remaining = archive.length
    let total = remaining

    // Check total file size <4go
    // gsutil cors set cors.json gs://attaboy-dev.appspot.com
    try {
      for (let i in archive) {
        let path = archive[i]
        getFile(path, function (blob) {
          createFile(path, blob, function () {
            // console.log('Downloading (' + (total - remaining) + '/' + total + ')')
            _.loader.update('Downloading files...', (total - remaining) / total)
            if (--remaining == 0) {
              // console.log('Creating a zip file')
              _.loader.update('Compressing files...', 1)
              zipFs.exportBlob(save)
            }
          })
        })
      }
    } catch (error) {
      _.loader.stop()
      console.error(error)
    }

    function getFile(path, callback) {
      let xhr = new XMLHttpRequest()
      xhr.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          callback(this.response)
        }
      }
      xhr.open('GET', path, true)
      xhr.responseType = 'blob'
      xhr.send()
    }

    function createFile(file, blob, callback) {
      let path
      if (file.indexOf('/files/') > 0) {
        path = file.split('/files/')[1].split('/')
      } else {
        path = file.split('/projects/')[1].split('/')
      }
      path[0] = archiveName // replace folder ID with folder name
      if (names[path[1]]) {
        path[1] = names[path[1]] // rename upload ID with file name...
      } else if (path[1] && path[1].indexOf('.html') > 0) {
        path.splice(1, 1) // ... or remove it if it's not a banner
      }
      path = path.reverse()
      let i = path.length
      let location = zipFs.root

      function next(entry) {
        location = entry.directory ? entry : location
        if (--i > 0) {
          next(
            location.getChildByName(path[i]) || location.addDirectory(path[i])
          )
        } else {
          location.addBlob(path[i], blob)
          callback()
        }
      }

      next(location)
    }

    function save(blob) {
      let a = document.querySelector('#download-link') as any
      let url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = archiveName + '.zip'
      a.click()
      window.URL.revokeObjectURL(url)
      _.loader.stop()
    }
  }

  makeid(): string {
    var text = ''
    var possible =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

    for (var i = 0; i < 30; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    return text
  }

  mapFiles(
    files: Array<File>,
    uploadpath: string,
    user: any,
    paths: Array<string> = []
  ): any {
    let remaining = 0
    let total = 0
    let dbimage = []
    let flat = []
    let dest = uploadpath + '/files/' + this.makeid() + '/'

    // var common_root = this.sharedStart(files.map(a => {
    // 	if (a.webkitRelativePath.split('/').length > 1)
    // 		return a.webkitRelativePath.split('/').slice(0, -2).join('/')
    // 	else
    // 		return a.webkitRelativePath
    // }))

    // common_root = common_root.substring(0, common_root.lastIndexOf('/') + 1)

    for (let i = 0; i < files.length; i++) {
      let file = files[i]
      let path = paths[i] || file.webkitRelativePath || file.name
      // let path = file.name
      let fullpath = this.storagePath + dest + path
      let folder = path.substring(0, path.lastIndexOf('/'))
      let name =
        file.name == 'index.html'
          ? folder.substring(folder.lastIndexOf('/') + 1)
          : file.name
      let key = dbkey(name)

      // Ignored files
      if (
        file.name == '.DS_Store' ||
        file.name == 'desktop.ini' ||
        file.name == '.localized' ||
        file.name == 'Thumbs.db'
      )
        continue

      remaining++
      total++

      if (file.name == 'index.html') {
        // path = path.split('/').slice(-2).join('/')
        dbimage[path] = {
          id: key,
          name: path.split('/').reverse()[1] || file.name,
          size: file.size,
          path: fullpath,
          // dbref: path.replace(/[^a-zA-Z0-9_]/g, ''),
          ref: dest + path,
          files: [dest + path],
          type: file.type,
          updated: firebase.database.ServerValue.TIMESTAMP,
          uploaded_by: {
            username: user.username,
            uid: user.uid,
          },
        }
        for (let j in dbimage) {
          if (j.indexOf(folder) == 0 && j.indexOf('index.html') == -1) {
            if (
              dbimage[j].name.indexOf(
                folder.substring(folder.lastIndexOf('/') + 1, folder.length) +
                  '.'
              ) == 0
            )
              dbimage[path].fallback = dbimage[j].path
            else dbimage[path].size += dbimage[j].size
            dbimage[path].files.push(dbimage[j].ref)
            delete dbimage[j]
          }
        }
      } else if (dbimage[folder + '/index.html']) {
        // Fallback
        if (
          file.name.indexOf(
            folder.substring(folder.lastIndexOf('/') + 1, folder.length) + '.'
          ) == 0
        )
          dbimage[folder + '/index.html'].fallback = fullpath
        else dbimage[folder + '/index.html'].size += file.size
        dbimage[folder + '/index.html'].files.push(dest + path)
      } else {
        dbimage[path] = {
          id: key,
          name: file.name,
          size: file.size,
          path: fullpath,
          ref: dest + path,
          type: file.type,
          updated: firebase.database.ServerValue.TIMESTAMP,
          uploaded_by: {
            username: user.username,
            uid: user.uid,
          },
        }
      }

      flat.push({
        file: file,
        path: path,
        ref: dest + path,
      })
    }

    // Create unique index object
    let databaseimage = {}
    for (let key in dbimage) {
      databaseimage[dbimage[key].id] = dbimage[key]
    }

    function dbkey(string) {
      return string.replace(/[^a-zA-Z0-9]/g, '-')
    }

    return {
      database: databaseimage,
      iterate: Object.values(dbimage),
      files: flat,
    }
  }

  uploadFiles(files: Array<File>): Promise<{}> {
    this.loader.start('Uploading files...', 0)
    return new Promise((resolve, reject) => {
      let total = files.length
      let remaining = total
      let progressTracker = {}

      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        let ref = firebase.storage().ref(file['ref'])
        let task = ref.put(file['file'])

        task.on(
          'state_changed',
          snapshot => {
            const progress =
              (snapshot['bytesTransferred'] / snapshot['totalBytes']) * 100
            progressTracker[snapshot['ref'].location.path] = {
              bytesTransferred: snapshot['bytesTransferred'],
              totalBytes: snapshot['totalBytes'],
            }
            this.showProgress(progressTracker)
          },
          error => {
            this.loader.stop()
            reject()
          },
          () => {
            // console.log('Uploading (' + (total - remaining) + '/' + total + ')')
            if (--remaining == 0) {
              resolve({
                upload: 'completed',
              })
            }
          }
        )
      }
    })
  }

  showProgress(progressTracker) {
    const arr = Object.values(progressTracker)
    const bytesTransferred = arr.reduce(
      (acc, val) => acc + val['bytesTransferred'],
      0
    )
    const totalBytes = arr.reduce((acc, val) => acc + val['totalBytes'], 0)
    this.loader.update('Uploading files...', bytesTransferred / totalBytes)
  }

  uploadFile(file: File, dest: string, name?: string): Promise<{}> {
    this.loader.start('Uploading files...', 0)

    return new Promise((resolve, reject) => {
      name = name ? name + '.' + file.name.split('.').pop() : file.name
      let upload = new Upload(file)
      let ref = firebase.storage().ref(dest)
      let fileref = ref.child(name)
      let task = fileref.put(file)

      task.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        snapshot => {
          // upload in progress
          upload.progress =
            (snapshot['bytesTransferred'] / snapshot['totalBytes']) * 100
          this.loader.update(
            'Uploading files...',
            snapshot['bytesTransferred'] / snapshot['totalBytes']
          )
        },
        error => {
          this.loader.stop()
          reject()
        },
        () => {
          // upload success
          upload.url = task.snapshot.downloadURL
          upload.name = upload.file.name
          this.loader.stop()
          resolve(upload)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/core/upload/upload.service.ts